import { createMemo } from 'react-use'
import { parseOptionsContractMonthString } from '~/modules/options/utils/parseOptionsContractMonthString'

export const useParseOptionsContractMonthString = createMemo(parseOptionsContractMonthString)
